import { ListTodo } from 'lucide-react'
import { useMemo, useState } from 'react'

import { useGetBrokersTasksRegisteredTaskTypes } from 'utils/web_api'

import ComboboxMultiSelectFilter from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

const WorkflowTaskTypeFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  // Fetch task types from backend using autogenerated hook
  const { data: taskTypesData, isLoading } = useGetBrokersTasksRegisteredTaskTypes({
    query: {
      staleTime: 1000 * 60 * 60, // Cache for 1 hour since task types rarely change
    },
  })

  // Transform API data to filter format and sort alphabetically
  const sortedTaskTypes = useMemo(() => {
    if (!taskTypesData) return []
    return taskTypesData
      .map((taskType) => ({
        value: taskType.task_type,
        label: taskType.display_name,
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
  }, [taskTypesData])

  const filteredOptions = sortedTaskTypes.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Task Type', options: filteredOptions }]}
        placeholder={
          isLoading
            ? 'Loading task types...'
            : 'Search task types to filter...'
        }
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={sortedTaskTypes}
          noSelectionText='Task Type'
          pluralIdentifier='task types'
        >
          <ListTodo size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default WorkflowTaskTypeFilter
